module.exports = __webpack_public_path__ + "static/terms_conditions_of_the_cardholder_loyalty_program_of_bank_card_131-56cb455a7a9101502b3a63d57a0c4649.pdf";